import { render } from "./PlaceEventsPanel.vue?vue&type=template&id=1c1be24b&scoped=true"
import script from "./PlaceEventsPanel.vue?vue&type=script&lang=js"
export * from "./PlaceEventsPanel.vue?vue&type=script&lang=js"

import "./PlaceEventsPanel.vue?vue&type=style&index=0&id=1c1be24b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1be24b"]])

export default __exports__